<!-- DETALLE DE UNA LIQUIDACIÓN DE COBRANZA (6.5). -->
<div class="flex flex-col gap-[16px]">
  <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
  </div>
  <p class="kb-hint m-0" *ngIf="cargando">Leyendo los abonos de la cobranza…</p>

  <div class="grid gap-6 lg:grid-cols-2" *ngIf="d">
    <div class="min-w-0 flex flex-col gap-[8px]">
      <p class="kb-dato-et">De lo aplicado a lo que se paga</p>
      <table class="kb-table">
        <tbody>
          <tr class="kb-tr" *ngFor="let c of d.cuenta" [class.font-semibold]="c.total">
            <td class="kb-td">{{ c.concepto }}</td><td class="kb-td kb-td-num">{{ c.usd | number:'1.2-2':'es' }}</td>
          </tr>
        </tbody>
      </table>
      <p class="kb-hint m-0" *ngIf="d.retenidos.n">{{ d.retenidos.n }} cobro(s) retenido(s) por la salud de los cobros, $ {{ d.retenidos.monto | number:'1.2-2':'es' }}: se ven en «Por resolver».</p>
    </div>
    <div class="min-w-0 flex flex-col gap-[8px]">
      <p class="kb-dato-et">Controles · reemplazan «cuadra con los pagarés»</p>
      <div class="flex items-start justify-between gap-3 border-b border-border py-[6px]" *ngFor="let k of d.controles">
        <span><i class="fas mr-2" [ngClass]="k.ok ? 'fa-check text-emerald-700' : 'fa-times text-red-700'" aria-hidden="true"></i>{{ k.nombre }}
          <span class="kb-td-sub block" *ngIf="k.casos?.length">casos: {{ k.casos.join(', ') }}</span></span>
        <span class="kb-badge" [ngClass]="k.ok ? 'kb-badge-exito' : 'kb-badge-peligro'">{{ k.ok ? 'Bien' : 'No pasa' }}</span>
      </div>
      <div class="flex flex-wrap gap-2 pt-[8px]">
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="descargar()"><i class="fas fa-file-excel mr-1" aria-hidden="true"></i>Excel de cobranza</button>
      </div>
      <p class="kb-hint m-0">El Excel trae todas las ventas y cada abono, los retenidos, los reversos y los controles.</p>
    </div>
  </div>

  <div class="min-w-0 flex flex-col gap-[8px]" *ngIf="d && d.ventas.total">
    <p class="kb-dato-et">Ventas del día · {{ d.ventas.filas.length }} de {{ d.ventas.total }}<ng-container *ngIf="d.ventas.filas.length < d.ventas.total"> (las de mayor monto; todas en el Excel)</ng-container></p>
    <div class="kb-table-envoltorio">
      <table class="kb-table">
        <thead class="kb-thead"><tr>
          <th class="kb-th">Crédito</th><th class="kb-th kb-th-num">Abonos</th><th class="kb-th kb-th-num">Cobrado</th><th class="kb-th kb-th-num">Comisión</th>
          <th class="kb-th kb-th-num">Cargo</th><th class="kb-th kb-th-num">Reversos</th><th class="kb-th kb-th-num">Neto</th>
        </tr></thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let v of d.ventas.filas">
            <td class="kb-td"><span class="kb-td-mono">{{ v.credito || v.venta }}</span><span class="kb-td-sub block" *ngIf="v.cliente">{{ v.cliente }}</span></td>
            <td class="kb-td kb-td-num">{{ v.abonos }}</td>
            <td class="kb-td kb-td-num">{{ v.cobrado | number:'1.2-2':'es' }}</td>
            <td class="kb-td kb-td-num">{{ v.comision | number:'1.2-2':'es' }}</td>
            <td class="kb-td kb-td-num">{{ v.cargo | number:'1.2-2':'es' }}</td>
            <td class="kb-td kb-td-num">{{ v.reversos ? (v.reversos | number:'1.2-2':'es') : '' }}<span class="kb-td-sub block" *ngIf="v.comision_devuelta">+{{ v.comision_devuelta | number:'1.2-2':'es' }} comisión</span></td>
            <td class="kb-td kb-td-num font-semibold">{{ v.neto | number:'1.2-2':'es' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="kb-card" *ngIf="d && d.abonos?.filas?.length">
    <div class="kb-card-header"><h3 class="kb-card-title">Abonos y su distribución</h3></div>
    <div class="kb-card-body flex flex-col gap-[8px]">
      <p class="kb-hint m-0">Un pago repartido en varias cuotas o créditos se lee como un solo pago: se muestra en la primera fila y las demás cuelgan de él (↳).</p>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr>
            <th class="kb-th">Pago</th><th class="kb-th kb-th-num">Pago USD</th><th class="kb-th">Crédito</th><th class="kb-th">Cuota</th><th class="kb-th">Cliente</th>
            <th class="kb-th kb-th-num">Aplicado a esta cuota</th><th class="kb-th">Aplicado</th><th class="kb-th">Se paga</th><th class="kb-th kb-th-num">Neto</th>
          </tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let a of d.abonos.filas; let i = index">
              <ng-container *ngIf="primeraDelPago(d.abonos.filas, i); else mismoPago">
                <td class="kb-td kb-td-titulo"><span class="kb-td-mono">{{ a.pago_referencia || '—' }}</span><span class="kb-td-sub block" *ngIf="a.pago_banco">{{ a.pago_banco }}</span></td>
                <td class="kb-td kb-td-num font-semibold">{{ a.pago_monto | number:'1.2-2':'es' }}</td>
              </ng-container>
              <ng-template #mismoPago>
                <td class="kb-td"><span class="kb-td-sub">↳ mismo pago</span></td>
                <td class="kb-td kb-td-num"></td>
              </ng-template>
              <td class="kb-td"><span class="kb-td-mono">{{ a.credito || a.venta || '—' }}</span></td>
              <td class="kb-td">{{ a.cuota_n ? (a.cuota_n + ' de ' + (a.cuotas_total || '—')) : '—' }}</td>
              <td class="kb-td">{{ a.cliente || '—' }}</td>
              <td class="kb-td kb-td-num">{{ a.monto | number:'1.2-2':'es' }}</td>
              <td class="kb-td">{{ a.fecha_aplicado ? (a.fecha_aplicado | date:'dd/MM/yyyy') : '—' }}</td>
              <td class="kb-td">{{ a.fecha_pago ? (a.fecha_pago | date:'dd/MM/yyyy') : '—' }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ a.neto | number:'1.2-2':'es' }}<span class="kb-td-sub block font-normal" *ngIf="a.comision || a.cargo">com. {{ a.comision | number:'1.2-2':'es' }} · cargo {{ a.cargo | number:'1.2-2':'es' }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="kb-hint m-0" *ngIf="d.abonos.total > d.abonos.filas.length">Se muestran {{ d.abonos.filas.length }} de {{ d.abonos.total }}; el Excel trae todos.</p>
    </div>
  </div>
</div>
